import instance from '../_http'

export default {
  /**
   * 添加
   * @param {*} website
   * @returns
   */
  add: (website) => {
    //JSON.parse(website.ruleDetail);
    return instance.post('/api/travel/charge-rule', website)
  },
  /**
   *  删除
   */
  remove: (id) => {
    return instance.delete(`/api/travel/charge-rule/${id}`)
  },
  /**
   * 更新
   * @param {*} website
   * @returns
   */
  update: (website) => {
    return instance.put('/api/travel/charge-rule', website)
  },
  /**
   * 查询
   * @param {*} query
   * @returns
   */
  query: (query, page) => {
    return instance.get('/api/travel/charge-rule', {
      params: {
        ...query,
        page: page.page,
        size: page.size,
        sort: page.sort
      }
    })
  },
  /**
   * 详情
   * @param {*} id
   * @returns
   */
  detail: (id) => {
    return instance.get(`/api/travel/charge-rule/${id}`)
  },
  /**
   * 修改默认站点
   * @param {*} id
   * @param {*} value
   * @returns
   */
  changeDefaultFlag: (id,value)=>{
    return instance.put(`/api/travel/charge-rule/${id}/defaultFlag/${value}`);
  }
}
